import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class SiteDocumentsIndexController extends Controller {
  @service currentPractice;
}
